module.exports = __webpack_public_path__ + "img/icon08.2832fc37.png";